import { ISiteVisitorType } from './types';

export default class SiteVisitorTypeFactory {
  static Create(): ISiteVisitorType {
    return {
      visitorTypeId: null,
      agreementId: null,
      questionnaireId: null,
      questionnaireEmailAddress: '',
      supplementaryQuestionnaireId: null,
      supplementaryQuestionnaireEmailAddress: '',
    };
  }
}
